import {
  SNACKBAR_SET_MESSAGE,
  SNACKBAR_CLEAR_MESSAGE,
  ALERT_BAR_CLOSE,
} from "./types"

export const clearSnackbar = () => ({
  type: SNACKBAR_CLEAR_MESSAGE,
})

export const setSnackbar = (
  message,
  variant = "info",
  autoHideDuration = variant === "error" ? null : 4000,
) => ({
  type: SNACKBAR_SET_MESSAGE,
  payload: {
    message,
    variant,
    timestamp: new Date().valueOf(),
    autoHideDuration,
  },
})

export const closeAlertBar = () => ({
  type: ALERT_BAR_CLOSE,
})

export function isEmpty(stateObject) {
  return !stateObject || stateObject.isEmpty
}

export function isLoaded(stateObject) {
  return !!stateObject?.isLoaded
}
